import styled from 'styled-components';
export const P = styled.p`
  margin-top: 0;
  ${({ dir }) => {
    if (dir.toLowerCase() === 'ltr') return `margin-left: 1em`;
    return `margin-right: 1em`;
  }}
`;
